import React from 'react';
import { InstagramIcon, TwitterIcon, LinkedinIcon, GithubIcon, YoutubeIcon, MailIcon, GlobeIcon, SlackIcon } from 'lucide-react';
export const Footer = ({
  onCursorChange
}) => {
  // Social media links that would typically be on a Linktree
  const socialLinks = [{
    icon: <InstagramIcon size={18} data-id="element-746" />,
    label: 'Instagram',
    url: 'https://instagram.com/cherylqian'
  }, {
    icon: <TwitterIcon size={18} data-id="element-747" />,
    label: 'Twitter',
    url: 'https://twitter.com/cherylqian'
  }, {
    icon: <LinkedinIcon size={18} data-id="element-748" />,
    label: 'LinkedIn',
    url: 'https://linkedin.com/in/cherylqian'
  }, {
    icon: <SlackIcon size={18} data-id="element-749" />,
    label: 'Slack',
    url: 'https://yacht-labs.slack.com'
  }, {
    icon: <GithubIcon size={18} data-id="element-750" />,
    label: 'GitHub',
    url: 'https://github.com/cherylqian'
  }, {
    icon: <YoutubeIcon size={18} data-id="element-751" />,
    label: 'YouTube',
    url: 'https://youtube.com/@cherylqian'
  }, {
    icon: <MailIcon size={18} data-id="element-752" />,
    label: 'Email',
    url: 'mailto:contact@cherylqian.com'
  }, {
    icon: <GlobeIcon size={18} data-id="element-753" />,
    label: 'Website',
    url: 'https://cherylqian.com'
  }];
  // Updated navigation structure to match header
  const footerNavigation = [{
    label: 'ABOUT',
    href: '#about',
    items: [{
      label: 'OVERVIEW',
      href: '#about'
    }, {
      label: 'ENDORSEMENTS',
      href: '#about-endorsements'
    }, {
      label: 'COLLABORATORS',
      href: '#about-collaborators'
    }, {
      label: 'METHODOLOGIES',
      href: '#disciplines'
    }]
  }, {
    label: 'WORK',
    href: '#portfolio',
    items: [{
      label: 'PORTFOLIO',
      href: '#portfolio'
    }, {
      label: 'DISCIPLINES',
      href: '#disciplines'
    }, {
      label: 'HALL OF FAME',
      href: '#hall-of-fame'
    }]
  }, {
    label: 'SHOP',
    href: '#shop',
    items: [{
      label: 'ALL PRODUCTS',
      href: '#shop'
    }, {
      label: 'APPAREL',
      href: '#shop-apparel'
    }, {
      label: 'ACCESSORIES',
      href: '#shop-accessories'
    }, {
      label: 'FEATURED',
      href: '#shop-featured'
    }]
  }, {
    label: 'CONNECT',
    href: '#contact',
    items: [{
      label: 'CONTACT',
      href: '#contact'
    }, {
      label: 'MEDIA',
      href: '#media-features'
    }, {
      label: 'COMPANIES',
      href: '#companies'
    }]
  }];
  return <footer className="w-full py-10 bg-[#060a10] text-[#e0e6f0] border-t border-[#1a2a40]/30 relative overflow-hidden" data-id="element-754">
      {/* Background effects */}
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-20 mix-blend-overlay" data-id="element-755"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-756">
        <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-757">
          <div className="mb-6 md:mb-0" data-id="element-758">
            <h3 className="text-lg font-bold font-heading text-gradient mb-1" onMouseEnter={() => onCursorChange('text')} onMouseLeave={() => onCursorChange('default')} data-id="element-759">
              CHERYL QIAN
            </h3>
            <p className="text-[#8a9cb9] text-sm font-mono" data-id="element-760">
              BIOLOGICAL DISTORTION · NYC
            </p>
          </div>
          {/* Footer Navigation with dropdowns */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10 mb-6 md:mb-0" data-id="element-761">
            {footerNavigation.map((section, idx) => <div key={idx} className="flex flex-col items-start" data-id="element-762">
                <a href={section.href} className="text-[#8a9cb9] hover:text-[#5ee7df] transition-colors duration-300 font-mono relative group mb-3" onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} data-id="element-763">
                  {section.label}
                  <span className="absolute bottom-0 left-0 h-px w-0 bg-[#5ee7df] group-hover:w-full transition-all duration-300" data-id="element-764"></span>
                </a>
                {section.items.length > 0 && <div className="flex flex-col space-y-2 pl-2 border-l border-[#1a2a40]/50" data-id="element-765">
                    {section.items.map((item, i) => <a key={i} href={item.href} className="text-[#8a9cb9] hover:text-[#5ee7df] transition-colors duration-300 font-mono text-xs relative group" onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} data-id="element-766">
                        {item.label}
                        <span className="absolute bottom-0 left-0 h-px w-0 bg-[#5ee7df] group-hover:w-full transition-all duration-300" data-id="element-767"></span>
                      </a>)}
                  </div>}
              </div>)}
          </div>
        </div>
        {/* Social Links Section */}
        <div className="mt-10 mb-8 flex flex-wrap justify-center gap-4" data-id="element-768">
          {socialLinks.map((link, index) => <a key={index} href={link.url} target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center rounded-full glass border border-[#1a2a40]/50 hover:border-[#5ee7df]/50 text-[#8a9cb9] hover:text-[#5ee7df] transition-all duration-300 group relative" onMouseEnter={() => onCursorChange('button')} onMouseLeave={() => onCursorChange('default')} aria-label={link.label} data-id="element-769">
              {link.icon}
              <span className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 bg-[#0a1018] px-2 py-1 rounded text-xs font-mono opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap" data-id="element-770">
                {link.label}
              </span>
              {/* Glow effect on hover */}
              <div className="absolute -inset-0.5 bg-gradient-to-br from-[#5ee7df]/30 to-[#2a4d7f]/30 opacity-0 group-hover:opacity-100 blur-sm transition-opacity duration-500 -z-10 rounded-full" data-id="element-771"></div>
            </a>)}
        </div>
        <div className="border-t border-[#1a2a40]/30 mt-8 pt-8 text-center text-[#8a9cb9] text-sm font-mono" data-id="element-772">
          <p className="relative group" data-id="element-773">
            <span className="relative z-10" data-id="element-774">
              © {new Date().getFullYear()} ORGANISM CHERYL QIAN. ALL RIGHTS
              RESERVED.
            </span>
            <span className="absolute inset-0 w-0 bg-[#0a1a24] group-hover:w-full transition-all duration-700 h-full z-0" data-id="element-775"></span>
          </p>
        </div>
      </div>
    </footer>;
};